<template>    
    <div class="py-4 container-fluid">
        <transition name="banner-slide">
        <div v-if="isSyncing || progress === 100">
            <RvoSyncBanner />
            </div>
        </transition>
        <div class="row">
            <div class="col-lg-12">                
                <div class="card mb-5">
                    <div class="card-header p-3 pt-2">
                        <div class="icon icon-lg icon-shape shadow text-center border-radius-xl mt-n4 position-absolute bg-gradient-success shadow-dark">
                            <i class="material-symbols-rounded opacity-10 text-white" aria-hidden="true">style</i>
                        </div>
                        <div class="d-flex align-items-center" style="margin-left: 4.5rem;">
                            <h6 class="mb-0 me-3">{{ $t('eartag.Ear_tags') }}</h6>

                            <p v-if="noEartagAvailable" class="text-danger text-sm mb-0">
                                {{ rVOMessage }}
                            </p>
                        </div>                        
                        <div class="row" >
                            <div class="col-lg-6">
                            </div>
                            <div class="col-lg-6 d-flex justify-content-end align-items-center gap-2" v-if="userRoleName === 'Keeper'">
                                <!--label
                                    class="btn btn-sm btn-success m-0 d-flex align-items-center"
                                    :class="{ 'disabled': isUploading }"
                                    @mouseenter="hover = true"
                                    @mouseleave="hover = false"
                                    style="transition: background 0.3s ease;"                                    
                                >
                                    <i v-if="!isUploading" class="material-symbols-rounded text-white me-1" style="font-size: 16px;">upload</i>
                                    <div v-if="isUploading" class="spinner-border spinner-border-sm text-white me-1" role="status"></div>
                                    <span>{{ isUploading ? $t('eartag.Uploading') : $t('eartag.Upload_File') }}</span>
                                    <input type="file" accept=".xls,.xlsx" @change="handleFileUpload" hidden />
                                </label-->
                            </div>
                        </div>
                    </div>
                    <div class="table-responsive">
                        <table id="eartag-list" class="table table-flush">
                            <thead class="thead-light">
                                <tr>
                                    <th class="text-xs font-weight-bold">{{ $t('association.RVORelationnumber') }}</th>
                                    <th class="text-xs font-weight-bold">{{ $t('eartag.Country_code') }}</th>
                                    <th class="text-xs font-weight-bold">{{ $t('eartag.Tag_number') }}</th>
                                    <th class="text-xs font-weight-bold">{{ $t('eartag.Work_number') }}</th>
                                    <th class="text-xs font-weight-bold">{{ $t('eartag.Name_supplier') }}</th>
                                    <th class="text-xs font-weight-bold">{{ $t('eartag.Supplie_date') }}</th>
                                    
                                    <!--th class="text-xs font-weight-bold">{{ $t('eartag.Manufacturer_code') }}</th>
                                    <th class="text-xs font-weight-bold">{{ $t('eartag.Manufacturer_name') }}</th>
                                    <th class="text-xs font-weight-bold">{{ $t('eartag.TagType_code') }}</th>
                                    <th class="text-xs font-weight-bold">{{ $t('eartag.TagType_description') }}</th>
                                    <th class="text-xs font-weight-bold">{{ $t('eartag.TagKind_code') }}</th>
                                    <th class="text-xs font-weight-bold">{{ $t('eartag.TagShape_code') }}</th>
                                    <th class="text-xs font-weight-bold">{{ $t('eartag.TagShape_description') }}</th-->
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in eartags" v-bind:key="item.id">  
                                    <td class="text-sm font-weight-normal">{{ item.rvorelationNumber }}</td>
                                    <td class="text-sm font-weight-normal">{{ item.countryCodeName }}</td>
                                    <td class="text-sm font-weight-normal">{{ item.tagNumber }}</td>
                                    <td class="text-sm font-weight-normal">{{ item.workNumber }}</td>
                                    <td class="text-sm font-weight-normal">{{ item.tagSupplierName }}</td>
                                    <td class="text-sm font-weight-normal">{{ formatDate(item.supplieDate) }}</td>

                                    <!--td class="text-sm font-weight-normal">{{ item.tagManufacturerCode }}</td>
                                    <td class="text-sm font-weight-normal">{{ item.tagManufacturerName }}</td>
                                    <td class="text-sm font-weight-normal">{{ item.tagTypeCode }}</td>
                                    <td class="text-sm font-weight-normal">{{ item.tagTypeName }}</td>
                                    <td class="text-sm font-weight-normal">{{ item.tagKindCode }}</td>
                                    <td class="text-sm font-weight-normal">{{ item.tagShapeCode }}</td>
                                    <td class="text-sm font-weight-normal">{{ item.tagShapeName }}</td-->                                    
                                </tr>
                            </tbody>                            
                        </table>
                    </div>                    
                </div>
            </div>
        </div>
        <div class="row"></div>
    </div>
</template>

<script>
import axios from 'axios';
import { nextTick } from 'vue';
import { DataTable } from "simple-datatables";
import RvoSyncBanner from "@/components/RvoSyncBanner.vue";
import { mapState, mapGetters } from 'vuex'

export default {
    name: 'Eartags_index_page',
    components: {
        RvoSyncBanner
    },
    data() {
        return {            
            eartags: [],
            gets: [],            
            dataTableInstance: null,
            isUploading: false,
            hover: false,
            noEartagAvailable: false,
            rVOMessage: '',
        }
    },
    computed: {
        userRoleName() {
            return this.$store.state.user?.roleName;
        },
        ...mapState('rvoSync', ['isSyncing', 'progress', 'cancelSource']),
        ...mapGetters('rvoSync', ['elapsedSeconds']),

        alertClass() {
            return this.elapsedSeconds > 15
                ? 'alert-warning'
                : 'alert-info';
        },

        elapsedFormatted() {
            const sec = this.elapsedSeconds;
            const minutes = Math.floor(sec / 60);
            const seconds = sec % 60;

            return `${minutes}:${seconds.toString().padStart(2, '0')}`;
        },

        isCompleted() {
            return this.progress === 100;
        },
    },
    async mounted() {
        try {
            const role = this.$store.state.roleName;
            const rVOConnected = this.$store.state.keeperRVOConnected;
            const rVORelationNumber = this.$store.state.keeperRVORelationNumber;
            const associationId = this.$store.state.associationAdminAssociationId;

            let url = null;

            if (role === 'Admin' || role === 'AssociationAdmin') {
                url = `/rvo/syncrvoeartags?associationId=${associationId}`;
            } 
            else if (role === 'Keeper') {
                if (!rVOConnected || !rVORelationNumber) {
                    this.$showSuccess(                        
                        this.$t('rvo.RVO_Synchronization_is_not_possible_without_user_mandate')
                    );
                    await this.loadEartags();
                    return;
                }

                url = `/rvo/syncrvoeartags?rvorelationnumber=${rVORelationNumber}`;
            } 
            else {
                console.warn('No valid role for RVO sync');
                await this.loadEartags();
                return;
            }

            const cancelSource = axios.CancelToken.source();
            this.$store.commit('rvoSync/START_SYNC', cancelSource);

            const response = await axios.get(url, {
                cancelToken: cancelSource.token
            });

            this.$store.commit('rvoSync/STOP_SYNC');

            if (!response?.data) {
                await this.loadEartags();
                return;
            }

            const result = response.data;

            this.noEartagAvailable = !result.success || result.count === 0;
            this.rVOMessage = this.$t('rvo.' + result.message);

            if (result.success) {
                if (result.count > 0) {
                    this.noEartagAvailable = false;
                    this.rVOMessage = '';
                }
                this.$showSuccess(this.$t('errors.' + result.message));
            } else {
                this.$showError(this.$t('rvo.' + result.message));
            }

            await this.loadEartags();

        } catch (e) {
            if (axios.isCancel(e)) {
                console.warn("Sync cancelled by user");
                return;
            }

            this.$store.commit('rvoSync/STOP_SYNC');

            const errorMessage =
                e.response?.data?.message ||
                e.message ||
                this.$t('errors.Something_went_wrong');

            this.$showError(
                `${this.$t('errors.Contact_system_admin')}: ${errorMessage}`
            );
        }
    },
    methods: { 
        formatDate(dateStr) {
            if (!dateStr) return '';
            const [year, month, day] = dateStr.split('-');
            return `${day}-${month}-${year}`;
        },           
        async handleFileUpload(event) {

            this.$store.commit('setShowLoading', true);

            const file = event.target.files[0];
            if (!file) {
                this.$showError('errors.No_file_selected_for_upload');
                return;
            }

            // Validate Excel file type
            const allowedTypes = [
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
                'application/vnd.ms-excel'                                           // .xls
            ];

            if (!allowedTypes.includes(file.type)) {
                this.$showError('errors.Only_excel_files_allowed');
                return;
            }

            this.isUploading = true;
            const formData = new FormData();
            formData.append('file', file);

            try {
                const response = await axios.post('eartag/import', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });

                const result = response.data;

                if (result.success) {
                    this.$showSuccess('errors.Success_free_eartags_uploaded_successfully');
                    this.loadEartags();
                }
            } catch (error) {
                const errorMessage = error.response?.data?.message || error.message || this.$t('errors.Something_went_wrong');
                this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
            } finally {
                this.isUploading = false;
                this.$store.commit('setShowLoading', false);
            }
        },

        async loadEartags() {
            this.$store.commit('setShowLoading', true);

            try {
                const role = this.$store.state.roleName;
                const rVORelationNumber = this.$store.state.keeperRVORelationNumber;

                let url = null;

                if (role === 'Admin') {
                    url = "eartag/getall";
                } 
                else if (role === 'Keeper') {
                    url = `/eartag/getbyrvorelationnumber?rvorelationnumber=${rVORelationNumber}`;
                } 
                else {
                    console.warn('Invalid role for loading eartags');
                    return;
                }

                const response = await axios.get(url);
                this.gets = response.data;

                if (!this.gets.success) {
                    this.$showError('errors.Contact_system_admin');
                    return;
                }

                const data = this.gets.data;

                if (!Array.isArray(data) || data.length === 0) {
                    this.$showSuccess('errors.No_ear_tags_found');
                    return;
                }

                this.eartags = data.sort((a, b) =>
                    (b.animalNumber ?? '').localeCompare(a.animalNumber ?? '')
                );

                await nextTick();

                this.initDataTable();

            } catch (e) {
                console.error(e);

                const errorMessage =
                    e.response?.data?.message ||
                    e.message ||
                    this.$t('errors.Something_went_wrong');

                this.$showError(
                    `${this.$t('errors.Contact_system_admin')}: ${errorMessage}`
                );

            } finally {
                this.$store.commit('setShowLoading', false);
            }
        },
        initDataTable() {
            const tableEl = document.querySelector("#eartag-list");
            if (!tableEl) return;

            try {
                if (this.dataTableInstance) {
                    this.dataTableInstance.destroy();
                    this.dataTableInstance = null;
                }
            } catch (err) {
                console.error('Error destroying DataTable:', err);
            }

            this.dataTableInstance = new DataTable("#eartag-list", {
                searchable: true,
                fixedHeight: false,
                perPageSelect: false,
                columns: Array.from({ length: 5 }, (_, i) => ({
                    select: i,
                    sortable: [0, 1, 2, 3, 4, 5].includes(i)
                })),
                labels: {
                    search: this.$t('datatable.Search'),
                    perPage: this.$t('datatable.PerPage'),
                    noRows: this.$t('datatable.NoRows'),
                    info: "Tonen {start} t/m {end} van {rows} items",
                    placeholder: this.$t('common.Search')
                }
            });
        },
        async deleteEartagModel(id) {   
            this.$swal
                .fire({
                    text: this.$t('common.Are_you_sure_to_delete_this_record'),
                    //icon: "error",
                    cancelButtonText: this.$t('common.Cancel'),
                    confirmButtonText: this.$t('common.Confirm_Delete'),
                    showCancelButton: true,
                    position: 'top-end'
                })
                .then(async (result) => {
                    if (result["isConfirmed"]) {                        
                        try {
                            
                            this.$store.commit('setShowLoading', true);

                            const response = await axios.delete("Eartag/" + id);
                            this.gets = response.data;

                            if (this.gets.success) {
                                try {
                                    const fetchResponse = await axios.get("Eartag/getall");
                                    const fetchResult = fetchResponse.data;

                                    if (fetchResult.success) {
                                        //this.eartags = fetchResult.data;
                                        this.eartags = fetchResult.data.sort((a, b) => (b.animalNumber ?? '').localeCompare(a.animalNumber ?? ''));
                                        

                                        if (this.dataTableInstance && typeof this.dataTableInstance.rows === 'function') {                                            
                                            this.dataTableInstance.rows().remove();                                            
                                        } else {
                                            console.log('DataTable instance is not valid or not initialized');
                                        }

                                        this.$showSuccess('errors.Success_record_is_deleted_successfully');                                        
                                    } else {
                                        throw new Error('Failed to fetch updated eartag list.');
                                    }
                                } catch (e) {
                                    const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                                    this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
                                }
                            } else {                                    
                                this.$showError('errors.Contact_system_admin');
                            }                            
                        } catch (e) {
                            const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                            this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
                        } finally {
                            this.$store.commit('setShowLoading', false);
                        }
                    }
                });            
        }
    }
}
</script>
<style scoped>
    ::v-deep .choices {
        width: auto !important;
        min-width: 270px;
    }

    .custom-association-dropdown {        
        border: 1px solid #4ca750;
    }

    /* Ensure the top container uses flex layout */
    ::v-deep .dataTable-top {
        display: flex !important;
        justify-content: flex-start !important;
        align-items: center !important;
    }

    /* Specifically target the search box to stay left aligned */
    ::v-deep .dataTable-top .dataTable-search {
        margin-right: auto !important;
        width: 50% !important;
    }

    ::v-deep .dataTable-top .dataTable-search .dataTable-input {
        width: 100% !important;
    }

    ::v-deep .dataTable-wrapper .dataTable-top .dataTable-search input {
        border: 1px solid #d2d2d2 !important;
    }

    /* Adjust the dropdown positioning (if present) */
    ::v-deep .dataTable-top .dataTable-dropdown {
        margin-left: 10px !important;
    }

    .banner-slide-enter-active,
    .banner-slide-leave-active {
        transition: all 0.8s ease;
        overflow: hidden;
    }

    .banner-slide-enter-from,
    .banner-slide-leave-to {
        opacity: 0;
        max-height: 0;
        margin-bottom: 0;
    }

    .banner-slide-enter-to,
    .banner-slide-leave-from {
        opacity: 1;
        max-height: 200px; /* large enough to fit banner */
        margin-bottom: 1rem;
    }
</style>